import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0ae19f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-2 footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, " © 2021-" + _toDisplayString(_ctx.thisYear) + " PropBank. All rights reserved. ", 1))
}